export const celebration = [
  { char: '🎉', name: 'Popper', nameZh: '慶祝', keywords: ['celebrate', 'party', '恭喜'] },
  { char: '🎊', name: 'Ball', nameZh: '彩球', keywords: ['party', 'celebrate'] },
  { char: '🎈', name: 'Balloon', nameZh: '氣球', keywords: ['birthday', 'party', '夢想'] },
  { char: '🎂', name: 'Cake', nameZh: '蛋糕', keywords: ['birthday', 'sweet', '慶生'] },
  { char: '🎁', name: 'Gift', nameZh: '禮物', keywords: ['present', 'surprise', '驚喜'] },
  { char: '🧧', name: 'Red Envelope', nameZh: '紅包', keywords: ['money', 'chinese', 'luck', '發財'] },
  { char: '🧨', name: 'Firecracker', nameZh: '鞭炮', keywords: ['boom', 'new year', '熱鬧'] },
  { char: '🎇', name: 'Sparkler', nameZh: '仙女棒', keywords: ['night', 'firework', '浪漫'] },
  { char: '🎆', name: 'Fireworks', nameZh: '煙火', keywords: ['celebrate', 'sky', '燦爛'] },
  { char: '🥂', name: 'Cheers', nameZh: '乾杯', keywords: ['drink', 'celebrate', '慶功'] },
  { char: '🥳', name: 'Party Face', nameZh: '派對臉', keywords: ['happy', 'celebrate'] },
  { char: '✨', name: 'Sparkles', nameZh: '閃耀', keywords: ['shine', 'magic', '亮點'] },
  { char: '💯', name: '100', nameZh: '滿分', keywords: ['perfect', 'best', '推薦'] },
  { char: '🔥', name: 'Fire', nameZh: '火熱', keywords: ['hot', 'trend', '爆紅'] },
  
  // --- 2025 新增氛圍 ---
  { char: '🪩', name: 'Mirror Ball', nameZh: '迪斯可球', keywords: ['dance', 'party', 'retro', '舞動'] },
  { char: '🪄', name: 'Magic Wand', nameZh: '魔杖', keywords: ['magic', 'change', '奇蹟'] },
  { char: '🧿', name: 'Nazar', nameZh: '惡魔之眼', keywords: ['protection', 'luck', '守護'] },
  { char: '🫗', name: 'Pouring Liquid', nameZh: '傾倒', keywords: ['drink', 'spill', '分享'] },
  { char: '🫙', name: 'Jar', nameZh: '罐子', keywords: ['store', 'save', '珍藏'] },
  { char: '🫧', name: 'Bubbles', nameZh: '泡泡', keywords: ['water', 'clean', '夢幻'] },
  { char: '🫥', name: 'Splat', nameZh: '噴濺', keywords: ['ink', 'art', 'hit', '潑墨', '藝術'] },
];